/* eslint-disable react-hooks/exhaustive-deps */
import { ForwardedRef, forwardRef, RefObject, useEffect } from 'react';
import { observer } from 'mobx-react';
// services
import AppService from 'modules/App';
import AnalyticsService from 'modules/Analytics';
// import OrdersTVService from 'modules/TradesPW3/Orders';
// import { LStorage } from 'modules/Storage';
// store
import { useStore } from 'modules/Stores';
// utils
import { createExitAllButton, createPnLElement, getTextColor } from 'utils/helpers/updatePositionPnLComponents';
// constants
import { EVENTS } from 'modules/Analytics/consts';
import { getNonDeliveryPositions } from 'modules/TradesPW3/Positions/utils';

const UpdatePositionPnl = (
  _props: unknown,
  positionPnlElementRef: ForwardedRef<HTMLElement>,
) => {
  const { totalPnL, groupedPositionsByType } = useStore('PositionsPW3Service');
  const isButtonDisabled = getNonDeliveryPositions(
    groupedPositionsByType.openPositions).length === 0;

  const handleExitAllClick = () => {
    AnalyticsService.sendEvent(
      EVENTS.POSITIONS_MTM_EXIT_ALL_BUTTON_CLICKED,
    );
    AppService.toggleModal('positionsMtmExitAllModal');
    // To be added in future to support do not show again
    // const skipModal = LStorage.getItem(
    //   'DO_NOT_SHOW_POSITIONS_MTM_MODAL',
    // ) === 'true';
    // if (skipModal) {
    //   OrdersTVService.placeExitAllMtmPositions(
    //     groupedPositionsByType.openPositions, true);
    // } else {
    //   AppService.toggleModal('positionsMtmExitAllModal');
    // }
  };

  // Initial setup of PnL and Exit All button
  useEffect(() => {
    let exitAllButtonElement: HTMLButtonElement | null = null;

    if (positionPnlElementRef && typeof positionPnlElementRef !== 'function') {
      const element = (positionPnlElementRef as RefObject<HTMLElement>).current;
      if (element) {
        // Create PnL container if it doesn't exist
        if (!element.querySelector('.pnl-container')) {
          const pnlElement = createPnLElement(totalPnL);
          element.appendChild(pnlElement);
        }

        // Handle the exit all button
        if (!element.querySelector('button')) {
          const exitAllButton = createExitAllButton({
            isDisabled: isButtonDisabled,
            onClick: handleExitAllClick,
          });
          element.appendChild(exitAllButton);
          exitAllButtonElement = element.querySelector('button');
        } else {
          exitAllButtonElement = element.querySelector('button');
          if (exitAllButtonElement) {
            exitAllButtonElement.style.background = isButtonDisabled
              ? 'var(--tv-color-toolbar-button-background-disabled)'
              : 'var(--tv-color-toolbar-button-sell-active)';
            exitAllButtonElement.style.cursor = isButtonDisabled ? 'not-allowed' : 'pointer';

            exitAllButtonElement.removeEventListener('click', handleExitAllClick);
            if (!isButtonDisabled) {
              exitAllButtonElement.addEventListener('click', handleExitAllClick);
            }
          }
        }
      }
    }

    return () => {
      if (exitAllButtonElement && !isButtonDisabled) {
        exitAllButtonElement.removeEventListener('click', handleExitAllClick);
      }
    };
  }, [
    (positionPnlElementRef as RefObject<HTMLElement>).current,
    isButtonDisabled,
  ]);

  // Update PnL value and color
  useEffect(() => {
    if (positionPnlElementRef && typeof positionPnlElementRef !== 'function') {
      const element = (positionPnlElementRef as RefObject<HTMLElement>).current;
      if (element) {
        const pnlValueSpan = element.querySelector('.pnl-value') as HTMLElement;
        if (pnlValueSpan) {
          pnlValueSpan.textContent = totalPnL || '00.00';
          const cleanedPnL = totalPnL.replace('₹', '');
          const pnlValueNumber = parseFloat(cleanedPnL || '0');
          pnlValueSpan.style.color = getTextColor(pnlValueNumber);
        }
      }
    }
  }, [totalPnL, positionPnlElementRef]);

  return null;
};

export default observer(forwardRef(UpdatePositionPnl));
